import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { setSelectedMember } from '../../store/slices/common';
import { createMember, updateMember } from '../../store/slices/api/inner/MemberSlice';
import { NAVIGATION } from '../../lib/navigation';
import { useNavigate } from 'react-router-dom';
import { menuItems } from '../Sidebar';
import _ from 'lodash'

const MemberForm = ({ defaultData }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedKeys, setSelectedKeys] = useState([]);

    const defaultValues = {
        name: defaultData?.admin_name ?? "",
        email: defaultData?.admin_username ?? "",
    };

    const afterAPICall = (response) => {
        dispatch(setSelectedMember(null));
        navigate(NAVIGATION.INNER_NAVIGATION.MEMBER.MEMBERS);
    };

    const beforeAPICall = (data) => {
        return {
            success: true,
            refactoredData: {
                roles: JSON.stringify(selectedKeys),
                userToUpdate: defaultData?.admin_id ?? "",
                ...data,
            },
        };
    };

    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateMember : createMember,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('name', defaultData?.admin_name ?? "");
            setValue('email', defaultData?.admin_username ?? "");

            if (defaultData?.admin_roles) {
                try {
                    // const sanitizedRoles = JSON.parse(defaultData.admin_roles
                    //     .replace(/'/g, '"')
                    //     .replace(/([a-zA-Z0-9_]+)/g, '"$1"');

                    const parsedRoles = JSON.parse(defaultData?.admin_roles);

                    if (Array.isArray(parsedRoles)) {
                        setSelectedKeys(parsedRoles);
                    } else {
                        console.error("Parsed admin_roles is not an array:", parsedRoles);
                    }
                } catch (error) {
                    console.error("Failed to parse admin_roles:", error);
                }
            }
        }
        else {
            setValue('name', "");
            setValue('email', "");
            setSelectedKeys([{ key: "dashboard", href: "/dashboard" }, { key: "logout", href: "/logout" }]);
        }
    }, [defaultData, setValue]);

    const handleCheckboxChange = (obj, isParent, subMenus) => {
        let newSelected = [...selectedKeys];
        const areadyExists = _.find(newSelected, { key: obj?.key });
        if (areadyExists) {
            newSelected = newSelected.filter((savedKey) => { return savedKey?.key !== obj?.key });
            subMenus.forEach((item) => {
                const areadyExists = _.find(newSelected, { key: item?.key });
                if (areadyExists) {
                    newSelected = newSelected.filter((selected) => selected?.key !== item?.key);
                }
            })
        } else {
            newSelected.push(obj);
            if (isParent && subMenus && subMenus.length > 0) {
                subMenus?.forEach((menu) => newSelected.push({ key: menu?.key, href: menu?.href }));
            }
        }
        let newlySelected = new Set(newSelected);
        setSelectedKeys([...newlySelected]);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-8">
            {/* Input Fields in a Single Row with Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <label htmlFor="name" className="block font-medium text-gray-700">Name</label>
                    <Input
                        control={control}
                        name="name"
                        rules={{ required: "This field is required" }}
                        className="mt-2 w-full"
                    />
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md">
                    <label htmlFor="email" className="block font-medium text-gray-700">Email</label>
                    <Input
                        control={control}
                        name="email"
                        type="email"
                        rules={{ required: "This field is required" }}
                        className="mt-2 w-full"
                    />
                </div>

                {!defaultData && (
                    <div className="bg-white p-6 rounded-lg shadow-md">
                        <label htmlFor="password" className="block font-medium text-gray-700">Password</label>
                        <Input
                            control={control}
                            name="password"
                            type="password"
                            rules={{ required: "This field is required" }}
                            className="mt-2 w-full"
                        />
                    </div>
                )}
            </div>

            {/* Menu items with submenus */}
            <div className="w-full space-y-4">
                {menuItems && menuItems.length > 0 && menuItems.map((menuItem) => (
                    
                    <div
                    key={menuItem.key}
                    className="bg-white p-4 rounded-lg shadow-md space-y-4" // Card styling for menu
                    >
                        {/* Main Menu Checkbox */}
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-3">
                                <input
                                    type="checkbox"
                                    checked={_.find(selectedKeys, { key: menuItem?.key }) ? true : false}
                                    onChange={() => handleCheckboxChange({ key: menuItem?.key, href: (menuItem?.href || null) }, true, menuItem?.submenu)}
                                    className="h-4 w-4"
                                    disabled={menuItem?.key === 'dashboard' || menuItem?.key === 'logout'}
                                />
                                <span className="font-semibold">{menuItem?.name}</span>
                            </div>
                        </div>

                        {/* Submenus */}
                        {menuItem?.submenu && (
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4 mx-4">
                                {menuItem?.submenu.length > 0 && menuItem?.submenu.map((child) => (
                                    <div key={child?.key} className="flex items-center space-x-3">
                                        <input
                                            type="checkbox"
                                            checked={_.find(selectedKeys, { key: child?.key }) ? true : false}
                                            onChange={() => handleCheckboxChange({ key: child?.key, href: (child?.href || null) }, false, [])}
                                            className="h-4 w-4"
                                        />
                                        <span>{child?.name}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Submit button */}
            <div className="flex justify-end mt-8">
                <Button isLoading={isLoading} className="px-6 py-2">
                    {defaultData ? "Save Changes" : "Submit"}
                </Button>
            </div>
        </form>
    );
};

export default MemberForm;
